import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { TextView } from 'src/core/ui/text.view';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { CardController } from 'src/app/shared/card.controller';
import { HeaderView } from 'src/app/shared/header.view';

interface BrandFormViewProps extends ComponentViewProps<BrandItem> {
	title: string,
	save: () => void,
	cancel: () => void,
	model: BrandItem;
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	setBusy(isBusy: boolean);
	onLogoChange: (ev: React.ChangeEvent<HTMLInputElement>) => void;
	onFooterChange: (ev: React.ChangeEvent<HTMLInputElement>) => void;
	contextService: any;
}

@observer
export class BrandFormView extends React.Component<BrandFormViewProps, any> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		if (model == null) return null;

		const mode = this.props.mode;
		const translations = model.dynamicProperties['translations'];
		const array: TabLanguageModel[] = [{ title: 'Description', dynamicProperties: translations }];
		let logo;
		if (model.logo != null && model.logo.length > 0) {
			let str = "";
			for (let i = 0; i < model.logo.length; i++) {
				str += String.fromCharCode(model.logo[i]);
			}
			logo = btoa(str);
		}
		let footer;
		if (model.footer != null && model.footer.length > 0) {
			let str = "";
			for (let i = 0; i < model.footer.length; i++) {
				str += String.fromCharCode(model.footer[i]);
			}
			footer = btoa(str);
		}

		return (
			<div className='window window-normal'>
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} lg={{ offset: 6, span: 12 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode={this.props.mode}
									onModeChanged={this.props.onModeChanged}
									save={this.props.save}
									cancel={this.props.cancel}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>
						<CardController
							mode={this.props.mode}
							icon="book"
							title="General information">
							<Row gutter={16}>
								<Col xs={24}>
									<TextView
										required
										onGetErrorMessage={() => this.props.model.validate(false, 'name')}
										mode={mode}
										label="Name"
										value={model.name}
										onChanged={newVal => model.name = newVal}
									/>
								</Col>
								<Col xs={24}>
									<TabLanguageController
										model={this.props.model}
										dynamicProperties={array}
										mode={mode}
										setBusy={this.props.setBusy}
										isRichTextBox={false}
									/>
								</Col>
								<Col xs={24}>
									<label>
										Header
									</label>
									<label htmlFor='logo' className="label-image text-center">
										<img src={'data:image/png;base64,' + logo} style={{ width: "100%" }} alt="Select an image" />
										<input id="logo" type="file" style={{ display: 'none' }} accept="image/*" onChange={this.props.onLogoChange} />
									</label>
								</Col>
								<Col xs={24}>
									<label>
										Footer
									</label>
									<label htmlFor='footer' className="label-image text-center">
										<img src={'data:image/png;base64,' + footer} style={{ width: "100%" }} alt="Select an image" />
										<input id="footer" type="file" style={{ display: 'none' }} accept="image/*" onChange={this.props.onFooterChange} />
									</label>
								</Col>
								<Col xs={24} lg={12}>
									<TextView
										onGetErrorMessage={() => this.props.model.validate(false, 'email')}
										mode={mode}
										label="Email sender"
										onChanged={newVal => model.dynamicProperties["email"] = newVal}
										value={this.props.model.dynamicProperties["email"]}
									/>
								</Col>
								<Col xs={24} lg={12}>
									<TextView
										onGetErrorMessage={() => this.props.model.validate(false, 'phone')}
										mode={mode}
										label="Phone"
										onChanged={newVal => model.dynamicProperties["phone"] = newVal}
										value={this.props.model.dynamicProperties["phone"]}
									/>
								</Col>
								<Col xs={24}>
									<TextView
										onGetErrorMessage={() => this.props.model.validate(false, 'address')}
										mode={mode}
										label="Address"
										onChanged={newVal => model.dynamicProperties["address"] = newVal}
										value={this.props.model.dynamicProperties["address"]}
									/>
								</Col>
								<Col xs={24}>
									<TextView
										onGetErrorMessage={() => this.props.model.validate(false, 'quoteNumberPrefix')}
										mode={mode}
										label="Prefix"
										required
										onChanged={newVal => model.dynamicProperties["quoteNumberPrefix"] = newVal}
										value={this.props.model.dynamicProperties["quoteNumberPrefix"]}
									/>
								</Col>
							</Row>
						</CardController>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/brands/form/brand-form.view.tsx